import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Timer10Icon(props: IconProps) {
    return <Icon {...props} iconKey={"timer_10"}/>
}
